import {
  Wrapper,
  Image,
  NameDiv,
  Name,
  Role,
  Placeholder
} from './styled.user-summary';
import defaultUser from '../../../common/images/avatar.jpeg';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import { useAuth } from 'Auth/auth-context';

function UserSummary({ width }) {
  const { isSuccess } = useAuth();

  const getUserProfile = JSON.parse(localStorage.getItem('user'));

  return !isSuccess ? (
    <Placeholder>
      <Skeleton variant='circle' width={34} height={32} />
      <Box style={{ marginLeft: '8px' }}>
        <Skeleton
          variant='rect'
          height={10}
          width={100}
          style={{ marginBottom: '5px' }}
        />
        <Skeleton variant='rect' height={10} width={100} />
      </Box>
    </Placeholder>
  ) : (
    <Wrapper>
      <>
        <Image src={defaultUser} />
        <NameDiv width={width}>
          <Name>{getUserProfile?.profiles[0]?.first_name}</Name>
          <Role>Human Resource</Role>
        </NameDiv>
      </>
    </Wrapper>
  );
}

export default UserSummary;
